import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento', 'ajuste_verba');

const ajusteVerbaActions = {
  gravar: { method: 'POST', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante` },
  verificarDadosExportacao: { methods: 'GET', url: `${basePath}/verificar-dados-exportacao` },
};

export default resource => resource(`${basePath}`, {}, ajusteVerbaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/ajuste-verba.js